import { render, staticRenderFns } from "./TraineeEmployeeReport.vue?vue&type=template&id=66e959f6"
import script from "./TraineeEmployeeReport.vue?vue&type=script&lang=js"
export * from "./TraineeEmployeeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports